import { render, staticRenderFns } from "./edit.text-blocks.page.vue?vue&type=template&id=443d424f&"
import script from "./edit.text-blocks.page.vue?vue&type=script&lang=js&"
export * from "./edit.text-blocks.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports